/* EKKO — bouton « Acheter maintenant » : ajoute l'article au panier puis ouvre directement le paiement. */
(() => {
  if (window.ekkoBuyNowReady) return;
  window.ekkoBuyNowReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.ekko-buy-now');
    if (!button || button.disabled) return;

    const form = document.getElementById(button.dataset.form);
    if (!form) return;

    const addToCart = form.querySelector('.add-to-cart-button');
    if (addToCart && addToCart.disabled) return;

    const label = button.querySelector('.ekko-buy-now__label');
    const wait = button.querySelector('.ekko-buy-now__wait');
    button.disabled = true;
    if (label && wait) {
      label.hidden = true;
      wait.hidden = false;
    }

    try {
      const data = new FormData(form);
      if (!data.get('quantity')) data.set('quantity', '1');
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
      });
      if (!response.ok) throw new Error('add failed');
      window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
    } catch (error) {
      button.disabled = false;
      if (label && wait) {
        label.hidden = false;
        wait.hidden = true;
      }
      // Repli : on passe par le panier classique.
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    }
  });
})();
